import React, { useEffect } from 'react';

function ExternalRedirect() {
  useEffect(() => {
    // Get the current path from Instagram
    const currentPath = window.location.pathname;
    
    // Determine the URL to redirect to
    // If it's just /open-external with no specific path, go to homepage
    const targetUrl = 'https://sunnysideupstorys.com/';
    
    // Set a timeout to allow the component to render before redirecting
    const timer = setTimeout(() => {
      // Try to open in external browser
      window.location.href = targetUrl;
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#f8f8f8'
    }}>
      <div style={{ marginBottom: '20px' }}>
        <div style={{
          border: '5px solid #f3f3f3',
          borderTop: '5px solid #d6ac0e',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px'
        }} />
      </div>
      <h1 style={{ fontSize: '24px', marginBottom: '16px' }}>Opening in your browser...</h1>
      <p style={{ fontSize: '16px', maxWidth: '600px', margin: '0 auto 20px' }}>
        For the best reading experience with our stories, we're redirecting you to your phone's default browser.
      </p>
      <a 
        href="https://sunnysideupstorys.com/"
        style={{
          display: 'inline-block',
          backgroundColor: '#d6ac0e',
          color: 'black',
          textDecoration: 'none',
          padding: '12px 24px',
          borderRadius: '5px',
          fontWeight: 'bold',
          fontSize: '16px'
        }}
      >
        Click here to open stories
      </a>
    </div>
  );
}

export default ExternalRedirect; 